import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'

export default {
  name: 'CollectPackageScreen',
  extends: BaseModal,
  data: function () {
    return {
      cp: null,
      cpus: [],
      selectedCpu: null,
    }
  },
  mounted() {
    this.fetchCpMapData(this.data.cpId)
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    CpuWireframe: () => import('@/vcs/_shared/cpu-wireframe/cmp.vue'),
  },
  methods: {
    fetchCpMapData() {
      axios({
        method: 'get',
        url: `collection_points/${this.data.cpId}/display_content`,
      })
        .then(response => {
          this.cp = response.data
          this.cpus = this.parseCpus(response.data.units).sort(this.sortCpus)
          this.selectedCpu = this.cpus.find(cpu => {
            return cpu.position == 0
          })
        })
        .catch(error => {
          this.$errorHumanized({ error })
        })
    },

    parseCpus(cpus) {
      // additional step for master-slave boxes, we move them to one cpu
      if (_.map(cpus, 'kind').indexOf('slave') != -1) {
        const masters = cpus.filter(cpu => cpu.kind == 'master')
        const slaves = cpus.filter(cpu => cpu.kind == 'slave')

        const myMasters = this.awakenMyMasters(masters, slaves)
        return myMasters
      } else {
        return cpus
      }
    },

    sortCpus(a, b) {
      return parseFloat(a.position) - parseFloat(b.position)
    },

    awakenMyMasters(masters, slaves) {
      return masters.map(master => {
        const belongingSlaves = slaves.filter(slave => slave.masterId == master.id)
        belongingSlaves.forEach(slave => {
          slave.boxes.forEach(box => {
            master.boxes.push(box)
          })
        })

        return master
      })
    },

    selectCpuHandler(id) {
      this.selectedCpu = this.cpus.find(cpu => {
        return cpu.id == id
      })
    },
    calculateCpuWidth() {
      return this.$refs.modal.clientWidth
    },
  },
}
